<div class="relative">
  <mat-icon
    class="r1-icon r1-icon-search-light absolute left-2 top-1/2 -translate-y-1/2 pointer-events-none"
    fontSet="r1-icon"
    [matTooltip]="tooltipMessage"
    matTooltipPosition="right"
  />
  <input
    type="text"
    class="w-full p-2 pl-9"
    [placeholder]="placeholder()"
    [formControl]="searchStringControl"
    (keydown)="listenForEsc($event)"
    data-testid="search-bar"
  />
  @if (!!searchStringControl.value && searchStringControl.value.length > 0) {
    <mat-icon
      class="r1-icon r1-icon-remove-light absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer"
      fontSet="r1-icon"
      (click)="resetState()"
    />
  }
</div>
